import { type Airror } from '@air/errors';
import { isAirrorInstance } from '@air/utils-error';

/**
 * Helper function to call Air API - returns data or throws if response is Airror.
 */
// biome-ignore lint/suspicious/noExplicitAny: Required to support SDK function overloads
export async function callAirApi<T>(apiCall: () => Promise<Airror<any> | T>): Promise<T> {
  const data = await apiCall();

  if (isAirrorInstance(data)) {
    throw data;
  }

  return data;
}

/**
 * Utility type to extract the response types from the SDK functions.
 * https://linear.app/air/issue/ENG-122/confirm-apiresponse-needs-any
 */
// biome-ignore lint/suspicious/noExplicitAny: SDK generic inference requires any
export type ApiResponse<T extends (args: any) => Promise<any>> = Extract<
  Awaited<ReturnType<T>>,
  { id: string } | { data: object }
>;
